export const containerCodes = [
    {wording: 'Bouteille', code: 'BO'},
    {wording: 'BIB(Fontaine à vin) / Cubi', code: 'BBG'},
    {wording: 'Canette', code: 'CNG'},
    {wording: 'Autre', code: 'OTHERS'}
];
